/* SOLSTICE — product.js : galerie, variantes, ATC AJAX, sticky bar, bundle, zoom */
(function () {
  'use strict';
  const root = document.querySelector('product-root');
  if (!root) return;

  /* ---------- Gallery ---------- */
  const slides = root.querySelectorAll('.gallery__slide');
  const thumbs = root.querySelectorAll('.gallery__thumb');
  let current = 0;

  function syncGalleryVideos() {
    slides.forEach((s, idx) => {
      const vid = s.querySelector('video');
      if (!vid) return;
      if (idx === current) {
        vid.muted = true;
        const p = vid.play();
        if (p && p.catch) p.catch(() => {});
      } else if (!vid.paused) {
        vid.pause();
      }
    });
  }
  function showSlide(i) {
    if (!slides.length) return;
    current = (i + slides.length) % slides.length;
    slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
    thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === current));
    const activeThumb = thumbs[current];
    if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    syncGalleryVideos();
  }
  syncGalleryVideos();
  thumbs.forEach((t, idx) => t.addEventListener('click', () => showSlide(idx)));
  root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(current - 1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(current + 1));

  /* Swipe (mobile) */
  const mainGallery = root.querySelector('.gallery__main');
  if (mainGallery) {
    let startX = 0;
    mainGallery.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    mainGallery.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 48) showSlide(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* Zoom modal */
  root.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
    const img = slides[current]?.querySelector('img');
    if (!img) return;
    const modal = document.createElement('div');
    modal.className = 'modal zoom-modal is-open';
    modal.innerHTML = `
      <div class="modal__overlay"></div>
      <div class="modal__panel">
        <button class="modal__close" aria-label="Close">✕</button>
        <img src="${img.currentSrc.replace(/width=\d+/, 'width=1800')}" alt="${img.alt || ''}">
      </div>`;
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    const close = () => { modal.remove(); document.body.style.overflow = ''; };
    modal.querySelector('.modal__overlay').addEventListener('click', close);
    modal.querySelector('.modal__close').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
  });

  /* ---------- Variants ---------- */
  const picker = root.querySelector('[data-variant-picker]');
  const variantsJson = picker?.querySelector('[data-variants-json]');
  const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
  const form = document.querySelector('[data-product-form]') || document.getElementById('ProductForm');

  function selectedOptions() {
    return [...picker.querySelectorAll('.vp')].map((fs) =>
      fs.querySelector('.is-selected')?.dataset.optionValue || null
    );
  }

  function findVariant(opts) {
    return variants.find((v) => opts.every((o, i) => v[`option${i + 1}`] === o));
  }

  function updateUI(variant) {
    const idInput = form?.querySelector('[data-variant-id]');
    const atc = form?.querySelector('[data-atc-button]');
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    if (!variant) {
      if (atc) { atc.disabled = true; atc.textContent = window.Solstice.strings.unavailable; }
      return;
    }
    if (idInput) idInput.value = variant.id;

    /* Price */
    const wrapper = root.querySelector('[data-price-wrapper] .price');
    if (wrapper) {
      let html = `<span class="price__now"${variant.compare_at_price > variant.price ? ' style="color:var(--c-sale)"' : ''}>${window.SolsticeUtils.formatMoney(variant.price)}</span>`;
      if (variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += `<s class="price__was">${window.SolsticeUtils.formatMoney(variant.compare_at_price)}</s><span class="price__save">-${pct}%</span>`;
      }
      wrapper.innerHTML = html;
    }
    if (stickyPrice) stickyPrice.textContent = window.SolsticeUtils.formatMoney(variant.price);

    /* ATC state */
    [atc, stickyAdd].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? window.Solstice.strings.addToCart : window.Solstice.strings.soldOut;
    });

    /* SKU */
    const sku = root.querySelector('[data-sku]');
    if (sku && variant.sku) sku.textContent = variant.sku;

    /* Gallery jump to variant media */
    if (variant.featured_media) {
      const idx = [...slides].findIndex((s) => s.dataset.mediaId == variant.featured_media.id);
      if (idx >= 0) showSlide(idx);
    }

    /* URL */
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant } }));
  }

  if (picker) {
    picker.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      const fs = btn.closest('.vp');
      fs.querySelectorAll('[data-option-value]').forEach((b) => { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      const label = fs.querySelector('[data-selected-value]');
      if (label) label.textContent = btn.dataset.optionValue;
      updateUI(findVariant(selectedOptions()));
    });
  }

  /* ---------- AJAX add to cart ---------- */
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const atc = form.querySelector('[data-atc-button]');
      const id = parseInt(form.querySelector('[data-variant-id]').value, 10);
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
      const original = atc.textContent;
      atc.disabled = true;
      atc.textContent = window.Solstice.strings.adding || '…';
      try {
        await window.SolsticeCart.add({ id, quantity: qty });
        document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      } catch (err) {
        window.SolsticeUtils.toast(err.message);
      }
      atc.disabled = false;
      atc.textContent = original;
    });
  }

  /* ---------- Sticky ATC ---------- */
  const sticky = document.querySelector('[data-sticky-atc]');
  if (sticky && form) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    });
    io.observe(form);
    sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => form.requestSubmit());
  }

  /* ---------- Bundle ---------- */
  const bundle = root.querySelector('[data-bundle]');
  if (bundle) {
    const totalEl = bundle.querySelector('[data-bundle-total]');
    const base = parseInt(totalEl?.dataset.basePrice || '0', 10);
    const update = () => {
      let total = base;
      bundle.querySelectorAll('[data-bundle-item]:checked').forEach((c) => { total += parseInt(c.dataset.price, 10); });
      if (totalEl) totalEl.textContent = window.SolsticeUtils.formatMoney(total);
    };
    bundle.addEventListener('change', update);
    update();
    bundle.querySelector('[data-bundle-add]')?.addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      btn.disabled = true;
      const items = [{ id: parseInt(form.querySelector('[data-variant-id]').value, 10), quantity: 1 }];
      bundle.querySelectorAll('[data-bundle-item]:checked').forEach((c) => items.push({ id: parseInt(c.value, 10), quantity: 1 }));
      try {
        await window.SolsticeCart.add(items);
        document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      } catch (err) { window.SolsticeUtils.toast(err.message); }
      btn.disabled = false;
    });
  }
})();
